<form #ngForm="ngForm" autocomplete="off" class="policy-studio-dialog">
    <div class="call-item-settings-dialog-container">
        <div class="item-name-container">
            <mat-form-field class="item-name">
                <mat-label>Name</mat-label>
                <input matInput required [(ngModel)]="callItem.title"
                       maxlength="255" name="first">
                <mat-error>
                    Name is <strong>required</strong>
                </mat-error>
            </mat-form-field>
            <ac-input-container label="Type" class="item-type">
                <ac-select [(acModel)]="callItem.type"
                           [searchable]="false"
                           [items]="policyStudioTypes"
                           [ngDisabled]="isEditMode"
                           (acModelChange)="policyStudioValidation($event)"
                           bindLabel="label"
                           bindValue="value">
                </ac-select>
            </ac-input-container>
        </div>

        <mat-radio-group class="admin-state" [(ngModel)]="callItem.adminState" name="admin-state">
            <mat-radio-button color="primary" [value]="'LOCKED'">
                <i class="fa fa-lock lock"></i>
            </mat-radio-button>
            <mat-radio-button color="primary" [value]="'UNLOCKED'">
                <i class="fa fa-unlock unlock"></i>
            </mat-radio-button>
        </mat-radio-group>

        <div class="rule-details-content">
            <ac-tabs tabsId="rule-settings-tab-set">
                <div class="match-and-action-container" *acTab="'Conditions'; id: 'source-tab'">
                    <div class="match">
                        <div class="match-container" *ngIf="callItem.type == 'USER'">
                            <div class="column-1">
                                <div class="select-with-map">
                                    <ac-input-container class="source-nodes-and-pcons" label="Source Nodes">
                                        <ac-select class="single-row"
                                                   [(acModel)]="callItem.match.nodeIds"
                                                   [multiple]="true"
                                                   [items]="nodesList"
                                                   [bindLabel]="'name'"
                                                   [bindValue]="'id'"
                                                   [allowClear]="true">
                                        </ac-select>
                                    </ac-input-container>
                                    <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                            nz-popover nzPopoverTrigger="click" [nzPopoverContent]="nodesDiagram" (click)="setNodesDiagramOptions()">
                                        <mat-icon class="icons-inner">pin_drop</mat-icon>
                                    </button>
                                </div>

                                <div class="select-with-map">
                                    <ac-input-container class="source-nodes-and-pcons" label="Source Peer Connections">
                                        <ac-select class="single-row"
                                                   [(acModel)]="callItem.match.pConIds"
                                                   [multiple]="true"
                                                   [items]="pConsList"
                                                   [bindLabel]="'name'"
                                                   [bindValue]="'id'"
                                                   [allowClear]="true">
                                        </ac-select>
                                    </ac-input-container>
                                    <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                            nz-popover nzPopoverTrigger="click" [nzPopoverContent]="pconsDiagram" (click)="setPConsDiagramOptions()">
                                        <mat-icon class="icons-inner">pin_drop</mat-icon>
                                    </button>
                                </div>

                                <div class="select-with-map">
                                  <ac-input-container class="source-nodes-and-pcons" label="Reroute Peer Connections ( for Refer and 3XX )">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.reroutePconIds"
                                               [multiple]="true"
                                               [items]="pConsList"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                  </ac-input-container>
                                  <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                          nz-popover nzPopoverTrigger="click" [nzPopoverContent]="reroutePconsDiagram" (click)="setReroutePConsDiagramOptions()">
                                    <mat-icon class="icons-inner">pin_drop</mat-icon>
                                  </button>
                                </div>

                                <ac-input-container label="Source Resource Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.topologyGroupIds"
                                               [multiple]="true"
                                               [items]="topologyGroupsList"
                                               [groupBy]="'type'"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Source Prefix / Prefix Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.srcPrefixGroups"
                                               [multiple]="true"
                                               [addCustomTags]="true"
                                               [items]="prefixGroups"
                                               bindLabel="name"
                                               [bindValue]="null"
                                               [combinedMode]="true"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Destination Prefix / Prefix Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.prefixGroups"
                                               [multiple]="true"
                                               [addCustomTags]="true"
                                               [items]="prefixGroups"
                                               bindLabel="name"
                                               [bindValue]="null"
                                               [combinedMode]="true"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Source User Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.srcUserGroupsIds"
                                               [multiple]="true"
                                               [items]="userGroupGroupsList"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Destination User Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.destUserGroupsIds"
                                               [multiple]="true"
                                               [items]="userGroupGroupsList"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Request type">
                                    <ac-select [(acModel)]="callItem.requestType"
                                               [items]="requestTypeOptions"
                                               [searchable]="false"
                                               [bindLabel]="'label'"
                                               [bindValue]="'value'">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="SIP condition group">
                                  <ac-select [(acModel)]="callItem.sipConditionGroupId"
                                             [items]="sipConditionGroups"
                                             [searchable]="true"
                                             [bindLabel]="'name'"
                                             [bindValue]="'id'"
                                             [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <div class="registered-users">
                                    <mat-checkbox [(ngModel)]="callItem.match.isRegisteredUsers"
                                                  [ngModelOptions]="{standalone: true}"
                                                  name="is-registered-users"
                                                  color="primary">
                                        Destination is a registered user in ARM
                                    </mat-checkbox>
                                </div>
                            </div>

                            <div class="column-2">
                                <ac-line-separator title="Match property dictionary"></ac-line-separator>
                                <div class="list-container">
                                    <div class="list-actions">
                                        <button (click)="addMatchAttribute(); updateIsInvalidMatchAttributesUser()" [disabled]="isMatchSelectOptionListEmpty()" mat-icon-button matTooltip="Add">
                                            <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                                        </button>
                                    </div>
                                    <div class="list-box">
                                        <div *ngFor="let item of callItem.match.attributes;let isOdd=odd;let isEven=even;let index = index;"
                                             class="list-item"
                                             [ngClass]="hasMatchSelection(item)"
                                             (click)="selectMatchCallItem(item)"
                                             [class.white]="isOdd"
                                             [class.gray]="isEven">

                                            <ac-input-container label="Match" class="match-type list-input">
                                                <ac-select [(acModel)]="item.field"
                                                           [searchable]="false"
                                                           (change)="updateMatchSelectOptionList(); updateIsInvalidMatchAttributesUser()"
                                                           [items]="matchSelectOptionList"
                                                           bindLabel="value"
                                                           bindValue="id">
                                                </ac-select>
                                            </ac-input-container>

                                            <select-from-dual-list sourceHeader="Options"
                                                                   targetHeader="Selected"
                                                                   class="attribute-option list-input"
                                                                   [source]="getAttributeOptions(attributeOptionList, item.values)"
                                                                   [attr.alternativeName]="index + '-match-value'"
                                                                   [target]="item.values"
                                                                   (targetChange)="updateAttributeItemsChange($event, item); updateIsInvalidMatchAttributesUser()"
                                                                   [bindLabel]="'name'" [bindValue]="'id'" width="230">
                                            </select-from-dual-list>

                                            <button (click)="removeMatchAttribute(index); updateIsInvalidMatchAttributesUser()" mat-icon-button matTooltip="Delete" class="delete-button">
                                                <mat-icon [svgIcon]="'delete'" class="icon-display"></mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <mat-error [ngStyle]="{'visibility': isInvalidMatchAttributesUser ? 'visible' : 'hidden' }"
                                           class="uris-error">At least one of the items must be filled if a user property is defined in the actions</mat-error>

                                <ac-line-separator separatorId="rule-sip-headers" title="Site / SIP headers"></ac-line-separator>

                                <div class="list-container" *ngIf="callItem.match">
                                    <div class="list-actions">
                                        <button (click)="addSipHeader(); updateIsInvalidMatchSipHeadersUser()" [disabled]="callItem.match.sipHeaders.length === 5" mat-icon-button matTooltip="Add">
                                            <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                                        </button>
                                    </div>
                                    <div class="list-box">
                                        <div *ngFor="let item of callItem.match.sipHeaders; let index = index;"
                                             (click)="sipHeaderSelectionHandler(index); updateIsInvalidMatchSipHeadersUser()"
                                             class="list-item"
                                             [ngClass]="{'item-selected': sipHeaderSelection === index, 'odd': index % 2 === 0}">

                                            <ac-input-container label="Name" class="list-action list-input">
                                                <ac-select class="sip-header-name"
                                                           selectId="sip-header-name"
                                                           [attr.alternativeName]="index + '-sip-header-name'"
                                                           [(acModel)]="item.name"
                                                           [addCustomTags]="true"
                                                           (acModelChange)="updateIsInvalidMatchSipHeadersUser()"
                                                           [items]="sipHeadersOptions">
                                                </ac-select>
                                            </ac-input-container>

                                            <ac-input-container label="Values" class="list-action elements-select list-input">
                                                <ac-select class="hide-arrow"
                                                           [(acModel)]="item.value"
                                                           [attr.alternativeName]="index + '-sip-header-value'"
                                                           (acModelChange)="updateIsInvalidMatchSipHeadersUser()"
                                                           [addCustomTags]="true"
                                                           [bindLabel]="null"
                                                           [bindValue]="null"
                                                           [multiple]="true"
                                                           [isOpen]="false"
                                                           [allowClear]="true">
                                                </ac-select>
                                            </ac-input-container>

                                            <button (click)="removeSipHeader(index); updateIsInvalidMatchSipHeadersUser()"
                                                    mat-icon-button matTooltip="Delete" class="delete-button">
                                                <mat-icon [svgIcon]="'delete'" class="icon-display"></mat-icon>
                                            </button>

                                        </div>
                                    </div>
                                </div>
                                <mat-error [ngStyle]="{'visibility': isInvalidMatchSipHeadersUser ? 'visible' : 'hidden' }"
                                           class="uris-error">At least one of the items must be filled</mat-error>
                            </div>
                        </div>

                        <div class="match-container" *ngIf="callItem.type == 'NUMBER_PORTABILITY'">
                            <div class="column-1">
                                <div class="select-with-map">
                                    <ac-input-container class="source-nodes-and-pcons" label="Source Nodes">
                                        <ac-select class="single-row"
                                                   [(acModel)]="callItem.match.nodeIds"
                                                   [multiple]="true"
                                                   [items]="nodesList"
                                                   [bindLabel]="'name'"
                                                   [bindValue]="'id'"
                                                   [allowClear]="true">
                                        </ac-select>
                                    </ac-input-container>
                                    <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                            nz-popover nzPopoverTrigger="click" [nzPopoverContent]="nodesDiagram" (click)="setNodesDiagramOptions()">
                                        <mat-icon class="icons-inner">pin_drop</mat-icon>
                                    </button>
                                </div>

                                <div class="select-with-map">
                                    <ac-input-container class="source-nodes-and-pcons" label="Source Peer Connections">
                                        <ac-select class="single-row"
                                                   [(acModel)]="callItem.match.pConIds"
                                                   [multiple]="true"
                                                   [items]="pConsList"
                                                   [bindLabel]="'name'"
                                                   [bindValue]="'id'"
                                                   [allowClear]="true">
                                        </ac-select>
                                    </ac-input-container>
                                    <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                            nz-popover nzPopoverTrigger="click" [nzPopoverContent]="pconsDiagram" (click)="setPConsDiagramOptions()">
                                        <mat-icon class="icons-inner">pin_drop</mat-icon>
                                    </button>
                                </div>

                                <div class="select-with-map">
                                  <ac-input-container class="source-nodes-and-pcons" label="Reroute Peer Connections ( for Refer and 3XX )">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.reroutePconIds"
                                               [multiple]="true"
                                               [items]="pConsList"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                  </ac-input-container>
                                  <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                          nz-popover nzPopoverTrigger="click" [nzPopoverContent]="reroutePconsDiagram" (click)="setReroutePConsDiagramOptions()">
                                    <mat-icon class="icons-inner">pin_drop</mat-icon>
                                  </button>
                                </div>

                                <ac-input-container label="Source Resource Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.topologyGroupIds"
                                               [multiple]="true"
                                               [items]="topologyGroupsList"
                                               [groupBy]="'type'"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Source Prefix / Prefix Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.srcPrefixGroups"
                                               [multiple]="true"
                                               [addCustomTags]="true"
                                               [items]="prefixGroups"
                                               bindLabel="name"
                                               [bindValue]="null"
                                               [combinedMode]="true"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Destination Prefix / Prefix Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.prefixGroups"
                                               [multiple]="true"
                                               [addCustomTags]="true"
                                               [items]="prefixGroups"
                                               bindLabel="name"
                                               [bindValue]="null"
                                               [combinedMode]="true"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Source User Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.srcUserGroupsIds"
                                               [multiple]="true"
                                               [items]="userGroupGroupsList"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Destination User Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.destUserGroupsIds"
                                               [multiple]="true"
                                               [items]="userGroupGroupsList"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>
                                <div class="registered-users">
                                    <mat-checkbox [(ngModel)]="callItem.match.isRegisteredUsers"
                                                  [ngModelOptions]="{standalone: true}"
                                                  name="is-registered-users"
                                                  color="primary">
                                        Destination is a registered user in ARM
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="column-2">
                                <ac-line-separator separatorId="rule-sip-headers" title="Site / SIP headers"></ac-line-separator>
                                <div class="list-container" *ngIf="callItem.match">
                                    <div class="list-actions">
                                        <button (click)="addSipHeader(); updateIsInvalidSipHeadersPortability()" [disabled]="callItem.match.sipHeaders.length === 5"
                                                mat-icon-button matTooltip="Add">
                                            <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                                        </button>
                                    </div>
                                    <div class="list-box">
                                        <div *ngFor="let item of callItem.match.sipHeaders; let index = index;"
                                             (click)="sipHeaderSelectionHandler(index)"
                                             class="sip-header-list-item list-item"
                                             [ngClass]="{'item-selected': sipHeaderSelection === index, 'odd': index % 2 === 0}">

                                            <ac-input-container label="Name" class="list-action list-input">
                                                <ac-select class="sip-header-name"
                                                           selectId="sip-header-name"
                                                           [attr.alternativeName]="index + '-sip-header-name'"
                                                           (acModelChange)="updateIsInvalidSipHeadersPortability()"
                                                           [(acModel)]="item.name"
                                                           [addCustomTags]="true"
                                                           [items]="sipHeadersOptions">
                                                </ac-select>
                                            </ac-input-container>

                                            <ac-input-container label="Values" class="list-action elements-select list-input">
                                                <ac-select class="sip-header-value"
                                                           [(acModel)]="item.value"
                                                           [attr.alternativeName]="index + '-sip-header-value'"
                                                           (acModelChange)="updateIsInvalidSipHeadersPortability()"
                                                           [addCustomTags]="true"
                                                           [bindLabel]="null"
                                                           [bindValue]="null"
                                                           [multiple]="true"
                                                           [isOpen]="false"
                                                           [allowClear]="true">
                                                </ac-select>
                                            </ac-input-container>

                                            <button (click)="removeSipHeader(index); updateIsInvalidSipHeadersPortability()"
                                                    mat-icon-button matTooltip="Delete" class="delete-button">
                                                <mat-icon [svgIcon]="'delete'" class="icon-display"></mat-icon>
                                            </button>

                                        </div>
                                    </div>
                                </div>
                                <mat-error [ngStyle]="{'visibility': isInvalidSipHeadersPortability ? 'visible' : 'hidden' }"
                                           class="uris-error">At least one of the items must be filled</mat-error>
                            </div>
                        </div>

                        <div class="match-container" *ngIf="callItem.type == 'CREDENTIALS'">
                            <div class="column-1">
                                <div class="select-with-map">
                                    <ac-input-container class="source-nodes-and-pcons" label="Source Nodes">
                                        <ac-select class="single-row"
                                                   [(acModel)]="callItem.match.nodeIds"
                                                   [multiple]="true"
                                                   [items]="nodesList"
                                                   [bindLabel]="'name'"
                                                   [bindValue]="'id'"
                                                   [allowClear]="true">
                                        </ac-select>
                                    </ac-input-container>
                                    <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                            nz-popover nzPopoverTrigger="click" [nzPopoverContent]="nodesDiagram" (click)="setNodesDiagramOptions()">
                                        <mat-icon class="icons-inner">pin_drop</mat-icon>
                                    </button>
                                </div>

                                <div class="select-with-map">
                                    <ac-input-container class="source-nodes-and-pcons" label="Source Peer Connections">
                                        <ac-select class="single-row"
                                                   [(acModel)]="callItem.match.pConIds"
                                                   [multiple]="true"
                                                   [items]="pConsList"
                                                   [bindLabel]="'name'"
                                                   [bindValue]="'id'"
                                                   [allowClear]="true">
                                        </ac-select>
                                    </ac-input-container>
                                    <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                            nz-popover nzPopoverTrigger="click" [nzPopoverContent]="pconsDiagram" (click)="setPConsDiagramOptions()">
                                        <mat-icon class="icons-inner">pin_drop</mat-icon>
                                    </button>
                                </div>

                                <div class="select-with-map">
                                  <ac-input-container class="source-nodes-and-pcons" label="Reroute Peer Connections ( for Refer and 3XX )">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.reroutePconIds"
                                               [multiple]="true"
                                               [items]="pConsList"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                  </ac-input-container>
                                  <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                          nz-popover nzPopoverTrigger="click" [nzPopoverContent]="reroutePconsDiagram" (click)="setReroutePConsDiagramOptions()">
                                    <mat-icon class="icons-inner">pin_drop</mat-icon>
                                  </button>
                                </div>

                                <ac-input-container label="Source Resource Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.topologyGroupIds"
                                               [multiple]="true"
                                               [items]="topologyGroupsList"
                                               [groupBy]="'type'"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Source User Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.srcUserGroupsIds"
                                               [multiple]="true"
                                               [items]="userGroupGroupsList"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <div class="list-container">
                                    <ac-line-separator title="Match property dictionary"></ac-line-separator>
                                    <div class="list-actions">
                                        <button (click)="addCredentialsMatchAttribute(); updateIsInvalidAttributesCredentials()"
                                                [disabled]="isCredentialsMatchSelectOptionListEmpty()" mat-icon-button matTooltip="Add">
                                            <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                                        </button>
                                    </div>
                                    <div class="list-box">
                                        <div *ngFor="let item of callItem.match.credentials;let isOdd=odd;let isEven=even;let index = index;"
                                             class="attribute-item list-item"
                                             [ngClass]="hasMatchSelection(item)"
                                             (click)="selectMatchCallItem(item)"
                                             [class.white]="isOdd"
                                             [class.gray]="isEven">

                                            <ac-input-container label="Match" class="match-type list-input">
                                                <ac-select [(acModel)]="item.field"
                                                           [searchable]="false"
                                                           [items]="matchCredentialsSelectOptionList"
                                                           [ngDisabled]="index === 0"
                                                           (change)="updateIsInvalidAttributesCredentials()"
                                                           bindLabel="value"
                                                           bindValue="id">
                                                </ac-select>
                                            </ac-input-container>

                                            <select-from-dual-list sourceHeader="Options"
                                                                   targetHeader="Selected"
                                                                   class="attribute-option list-input"
                                                                   [attr.alternativeName]="index + '-match-value'"
                                                                   [source]="getAttributeOptions(attributeOptionList, item.values)"
                                                                   [target]="item.values"
                                                                   (targetChange)="updateAttributeItemsChange($event, item); updateIsInvalidAttributesCredentials()"
                                                                   [bindLabel]="'name'" [bindValue]="'id'" width="240">
                                            </select-from-dual-list>

                                            <button (click)="removeCredentialsMatchAttribute(index); updateIsInvalidAttributesCredentials()"
                                                    [disabled]="isOnlyUriUserSelected() || (matchSelected && matchSelected.id === 0)" mat-icon-button matTooltip="Delete" class="delete-button">
                                                <mat-icon [svgIcon]="'delete'" class="icon-display"></mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <mat-error [ngStyle]="{'visibility': isInvalidAttributesCredentials ? 'visible' : 'hidden' }"
                                           class="uris-error">At least one of the items must be filled</mat-error>
                            </div>
                            <div class="column-2"></div>

                        </div>

                        <div class="match-container" *ngIf="callItem.type == 'BLACK_LIST'">
                            <div class="column-1">
                                <div class="select-with-map">
                                    <ac-input-container class="source-nodes-and-pcons" label="Source Nodes">
                                        <ac-select class="single-row"
                                                   [(acModel)]="callItem.match.nodeIds"
                                                   [multiple]="true"
                                                   [items]="nodesList"
                                                   [bindLabel]="'name'"
                                                   [bindValue]="'id'"
                                                   [allowClear]="true">
                                        </ac-select>
                                    </ac-input-container>
                                    <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                            nz-popover nzPopoverTrigger="click" [nzPopoverContent]="nodesDiagram" (click)="setNodesDiagramOptions()">
                                        <mat-icon class="icons-inner">pin_drop</mat-icon>
                                    </button>
                                </div>

                                <div class="select-with-map">
                                    <ac-input-container class="source-nodes-and-pcons" label="Source Peer Connections">
                                        <ac-select class="single-row"
                                                   [(acModel)]="callItem.match.pConIds"
                                                   [multiple]="true"
                                                   [items]="pConsList"
                                                   [bindLabel]="'name'"
                                                   [bindValue]="'id'"
                                                   [allowClear]="true">
                                        </ac-select>
                                    </ac-input-container>
                                    <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                            nz-popover nzPopoverTrigger="click" [nzPopoverContent]="pconsDiagram" (click)="setPConsDiagramOptions()">
                                        <mat-icon class="icons-inner">pin_drop</mat-icon>
                                    </button>
                                </div>

                                <div class="select-with-map">
                                  <ac-input-container class="source-nodes-and-pcons" label="Reroute Peer Connections ( for Refer and 3XX )">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.reroutePconIds"
                                               [multiple]="true"
                                               [items]="pConsList"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                  </ac-input-container>
                                  <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                          nz-popover nzPopoverTrigger="click" [nzPopoverContent]="reroutePconsDiagram" (click)="setReroutePConsDiagramOptions()">
                                    <mat-icon class="icons-inner">pin_drop</mat-icon>
                                  </button>
                                </div>

                                <ac-input-container label="Source Resource Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.topologyGroupIds"
                                               [multiple]="true"
                                               [items]="topologyGroupsList"
                                               [groupBy]="'type'"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Source Prefix / Prefix Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.srcPrefixGroups"
                                               [multiple]="true"
                                               [addCustomTags]="true"
                                               [items]="prefixGroups"
                                               bindLabel="name"
                                               [bindValue]="null"
                                               [combinedMode]="true"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Destination Prefix / Prefix Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.prefixGroups"
                                               [multiple]="true"
                                               [addCustomTags]="true"
                                               [items]="prefixGroups"
                                               bindLabel="name"
                                               [bindValue]="null"
                                               [combinedMode]="true"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Source User Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.srcUserGroupsIds"
                                               [multiple]="true"
                                               [items]="userGroupGroupsList"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Destination User Groups">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.match.destUserGroupsIds"
                                               [multiple]="true"
                                               [items]="userGroupGroupsList"
                                               [bindLabel]="'name'"
                                               [bindValue]="'id'"
                                               [allowClear]="true">
                                    </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Request type">
                                    <ac-select [(acModel)]="callItem.requestType"
                                               [items]="requestTypeOptions"
                                               [searchable]="false"
                                               [bindLabel]="'label'"
                                               [bindValue]="'value'">
                                    </ac-select>
                                </ac-input-container>

                                <div class="registered-users">
                                    <mat-checkbox [(ngModel)]="callItem.match.isRegisteredUsers"
                                                  [ngModelOptions]="{standalone: true}"
                                                  name="is-registered-users"
                                                  color="primary">
                                        Destination is a registered user in ARM
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="column-2">
                                <div class="list-container">
                                    <ac-line-separator title="Match property dictionary"></ac-line-separator>
                                    <div class="list-actions">
                                        <button (click)="addMatchAttribute(); updateIsInvalidMatchAttributesBlacklist()" [disabled]="isMatchSelectOptionListEmpty()" mat-icon-button matTooltip="Add">
                                            <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                                        </button>
                                    </div>
                                    <div class="list-box">
                                        <div *ngFor="let item of callItem.match.attributes;let isOdd=odd;let isEven=even;let index = index;"
                                             class="list-item"
                                             [ngClass]="hasMatchSelection(item)"
                                             (click)="selectMatchCallItem(item)"
                                             [class.white]="isOdd"
                                             [class.gray]="isEven">

                                            <ac-input-container label="Match" class="match-type list-input">
                                                <ac-select [(acModel)]="item.field"
                                                           [searchable]="false"
                                                           (change)="updateMatchSelectOptionList(); updateIsInvalidMatchAttributesBlacklist()"
                                                           [items]="matchSelectOptionList"
                                                           bindLabel="value"
                                                           bindValue="id">
                                                </ac-select>
                                            </ac-input-container>

                                            <select-from-dual-list sourceHeader="Options"
                                                                   targetHeader="Selected"
                                                                   class="attribute-option list-input"
                                                                   [source]="getAttributeOptions(attributeOptionList, item.values)"
                                                                   [attr.alternativeName]="index + '-match-value'"
                                                                   [target]="item.values"
                                                                   (targetChange)="updateAttributeItemsChange($event, item); updateIsInvalidMatchAttributesBlacklist()"
                                                                   [bindLabel]="'name'" [bindValue]="'id'" width="230">
                                            </select-from-dual-list>

                                            <button (click)="removeMatchAttribute(index); updateIsInvalidMatchAttributesBlacklist()" mat-icon-button matTooltip="Delete" class="delete-button">
                                                <mat-icon [svgIcon]="'delete'" class="icon-display"></mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <mat-error [ngStyle]="{'visibility': isInvalidMatchAttributesBlacklist ? 'visible' : 'hidden' }"
                                           class="uris-error">Field and values must be provided for each item</mat-error>

                                <ac-line-separator separatorId="rule-sip-headers" title="Site / SIP headers"></ac-line-separator>

                                <div class="list-container" *ngIf="callItem.match">
                                    <div class="list-actions">
                                        <button (click)="addSipHeader(); updateIsInvalidMatchSipHeadersBlacklist()" [disabled]="callItem.match.sipHeaders.length === 5" mat-icon-button matTooltip="Add">
                                            <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                                        </button>
                                    </div>
                                    <div class="list-box">
                                        <div *ngFor="let item of callItem.match.sipHeaders; let index = index;"
                                             (click)="sipHeaderSelectionHandler(index); updateIsInvalidMatchSipHeadersBlacklist()"
                                             class="list-item"
                                             [ngClass]="{'item-selected': sipHeaderSelection === index, 'odd': index % 2 === 0}">

                                            <ac-input-container label="Name" class="list-action list-input">
                                                <ac-select class="sip-header-name"
                                                           selectId="sip-header-name"
                                                           [attr.alternativeName]="index + '-sip-header-name'"
                                                           [(acModel)]="item.name"
                                                           [addCustomTags]="true"
                                                           (acModelChange)="updateIsInvalidMatchSipHeadersBlacklist()"
                                                           [items]="sipHeadersOptions">
                                                </ac-select>
                                            </ac-input-container>

                                            <ac-input-container label="Values" class="list-action elements-select list-input">
                                                <ac-select class="sip-header-value"
                                                           [(acModel)]="item.value"
                                                           [attr.alternativeName]="index + '-sip-header-value'"
                                                           (acModelChange)="updateIsInvalidMatchSipHeadersBlacklist()"
                                                           [addCustomTags]="true"
                                                           [bindLabel]="null"
                                                           [bindValue]="null"
                                                           [multiple]="true"
                                                           [isOpen]="false"
                                                           [allowClear]="true">
                                                </ac-select>
                                            </ac-input-container>

                                            <button (click)="removeSipHeader(index); updateIsInvalidMatchSipHeadersBlacklist()"
                                                    mat-icon-button matTooltip="Delete" class="delete-button">
                                                <mat-icon [svgIcon]="'delete'" class="icon-display"></mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <mat-error [ngStyle]="{'visibility': isInvalidMatchSipHeadersBlacklist ? 'visible' : 'hidden' }"
                                           class="uris-error">Name and values must be provided for each item</mat-error>
                            </div>
                        </div>
                      <div class="match-container" *ngIf="callItem.type == 'DIDS_COUNT_MATCH'">
                        <div class="column-1">
                          <div class="select-with-map">
                            <ac-input-container class="source-nodes-and-pcons" label="Source Nodes">
                              <ac-select class="single-row"
                                         [(acModel)]="callItem.match.nodeIds"
                                         [multiple]="true"
                                         [items]="nodesList"
                                         [bindLabel]="'name'"
                                         [bindValue]="'id'"
                                         [allowClear]="true">
                              </ac-select>
                            </ac-input-container>
                            <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                    nz-popover nzPopoverTrigger="click" [nzPopoverContent]="nodesDiagram" (click)="setNodesDiagramOptions()">
                              <mat-icon class="icons-inner">pin_drop</mat-icon>
                            </button>
                          </div>

                          <div class="select-with-map">
                            <ac-input-container class="source-nodes-and-pcons" label="Source Peer Connections">
                              <ac-select class="single-row"
                                         [(acModel)]="callItem.match.pConIds"
                                         [multiple]="true"
                                         [items]="pConsList"
                                         [bindLabel]="'name'"
                                         [bindValue]="'id'"
                                         [allowClear]="true">
                              </ac-select>
                            </ac-input-container>
                            <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                    nz-popover nzPopoverTrigger="click" [nzPopoverContent]="pconsDiagram" (click)="setPConsDiagramOptions()">
                              <mat-icon class="icons-inner">pin_drop</mat-icon>
                            </button>
                          </div>

                          <div class="select-with-map">
                            <ac-input-container class="source-nodes-and-pcons" label="Reroute Peer Connections ( for Refer and 3XX )">
                              <ac-select class="single-row"
                                         [(acModel)]="callItem.match.reroutePconIds"
                                         [multiple]="true"
                                         [items]="pConsList"
                                         [bindLabel]="'name'"
                                         [bindValue]="'id'"
                                         [allowClear]="true">
                              </ac-select>
                            </ac-input-container>
                            <button mat-icon-button color="primary" class="combined-action" title="Select from map"
                                    nz-popover nzPopoverTrigger="click" [nzPopoverContent]="reroutePconsDiagram" (click)="setReroutePConsDiagramOptions()">
                              <mat-icon class="icons-inner">pin_drop</mat-icon>
                            </button>
                          </div>

                          <ac-input-container label="Source Resource Groups">
                            <ac-select class="single-row"
                                       [(acModel)]="callItem.match.topologyGroupIds"
                                       [multiple]="true"
                                       [items]="topologyGroupsList"
                                       [groupBy]="'type'"
                                       [bindLabel]="'name'"
                                       [bindValue]="'id'"
                                       [allowClear]="true">
                            </ac-select>
                          </ac-input-container>

                          <ac-input-container label="Source Prefix / Prefix Groups">
                            <ac-select class="single-row"
                                       [(acModel)]="callItem.match.srcPrefixGroups"
                                       [multiple]="true"
                                       [addCustomTags]="true"
                                       [items]="prefixGroups"
                                       bindLabel="name"
                                       [bindValue]="null"
                                       [combinedMode]="true"
                                       [allowClear]="true">
                            </ac-select>
                          </ac-input-container>

                          <ac-input-container label="Destination Prefix / Prefix Groups">
                            <ac-select class="single-row"
                                       [(acModel)]="callItem.match.prefixGroups"
                                       [multiple]="true"
                                       [addCustomTags]="true"
                                       [items]="prefixGroups"
                                       bindLabel="name"
                                       [bindValue]="null"
                                       [combinedMode]="true"
                                       [allowClear]="true">
                            </ac-select>
                          </ac-input-container>

                          <ac-input-container label="Source User Groups">
                            <ac-select class="single-row"
                                       [(acModel)]="callItem.match.srcUserGroupsIds"
                                       [multiple]="true"
                                       [items]="userGroupGroupsList"
                                       [bindLabel]="'name'"
                                       [bindValue]="'id'"
                                       [allowClear]="true">
                            </ac-select>
                          </ac-input-container>

                          <ac-input-container label="Destination User Groups">
                            <ac-select class="single-row"
                                       [(acModel)]="callItem.match.destUserGroupsIds"
                                       [multiple]="true"
                                       [items]="userGroupGroupsList"
                                       [bindLabel]="'name'"
                                       [bindValue]="'id'"
                                       [allowClear]="true">
                            </ac-select>
                          </ac-input-container>

                          <ac-input-container label="Request type">
                            <ac-select [(acModel)]="callItem.requestType"
                                       [items]="requestTypeOptions"
                                       [searchable]="false"
                                       [bindLabel]="'label'"
                                       [bindValue]="'value'">
                            </ac-select>
                          </ac-input-container>

                          <div class="registered-users">
                            <mat-checkbox [(ngModel)]="callItem.match.isRegisteredUsers"
                                          [ngModelOptions]="{standalone: true}"
                                          name="is-registered-users"
                                          color="primary">
                              Destination is a registered user in ARM
                            </mat-checkbox>
                          </div>
                        </div>
                        <div class="column-2">
                          <div class="list-container">
                            <ac-line-separator title="Match property dictionary"></ac-line-separator>
                            <div class="list-actions">
                              <button (click)="addMatchAttribute(); updateIsInvalidMatchAttributesBlacklist()" [disabled]="isMatchSelectOptionListEmpty()" mat-icon-button matTooltip="Add">
                                <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                              </button>
                            </div>
                            <div class="list-box">
                              <div *ngFor="let item of callItem.match.attributes;let isOdd=odd;let isEven=even;let index = index;"
                                   class="list-item"
                                   [ngClass]="hasMatchSelection(item)"
                                   (click)="selectMatchCallItem(item)"
                                   [class.white]="isOdd"
                                   [class.gray]="isEven">

                                <ac-input-container label="Match" class="match-type list-input">
                                  <ac-select [(acModel)]="item.field"
                                             [searchable]="false"
                                             (change)="updateMatchSelectOptionList(); updateIsInvalidMatchAttributesBlacklist()"
                                             [items]="matchSelectOptionList"
                                             bindLabel="value"
                                             bindValue="id">
                                  </ac-select>
                                </ac-input-container>

                                <select-from-dual-list sourceHeader="Options"
                                                       targetHeader="Selected"
                                                       class="attribute-option list-input"
                                                       [source]="getAttributeOptions(attributeOptionList, item.values)"
                                                       [attr.alternativeName]="index + '-match-value'"
                                                       [target]="item.values"
                                                       (targetChange)="updateAttributeItemsChange($event, item); updateIsInvalidMatchAttributesBlacklist()"
                                                       [bindLabel]="'name'" [bindValue]="'id'" width="230">
                                </select-from-dual-list>

                                <button (click)="removeMatchAttribute(index); updateIsInvalidMatchAttributesBlacklist()" mat-icon-button matTooltip="Delete" class="delete-button">
                                  <mat-icon [svgIcon]="'delete'" class="icon-display"></mat-icon>
                                </button>
                              </div>
                            </div>
                          </div>

                          <mat-error [ngStyle]="{'visibility': isInvalidMatchAttributesBlacklist ? 'visible' : 'hidden' }"
                                     class="uris-error">Field and values must be provided for each item</mat-error>

                          <ac-line-separator separatorId="rule-sip-headers" title="Site / SIP headers"></ac-line-separator>

                          <div class="list-container" *ngIf="callItem.match">
                            <div class="list-actions">
                              <button (click)="addSipHeader(); updateIsInvalidMatchSipHeadersBlacklist()" [disabled]="callItem.match.sipHeaders.length === 5" mat-icon-button matTooltip="Add">
                                <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                              </button>
                            </div>
                            <div class="list-box">
                              <div *ngFor="let item of callItem.match.sipHeaders; let index = index;"
                                   (click)="sipHeaderSelectionHandler(index); updateIsInvalidMatchSipHeadersBlacklist()"
                                   class="list-item"
                                   [ngClass]="{'item-selected': sipHeaderSelection === index, 'odd': index % 2 === 0}">

                                <ac-input-container label="Name" class="list-action list-input">
                                  <ac-select class="sip-header-name"
                                             selectId="sip-header-name"
                                             [attr.alternativeName]="index + '-sip-header-name'"
                                             [(acModel)]="item.name"
                                             [addCustomTags]="true"
                                             (acModelChange)="updateIsInvalidMatchSipHeadersBlacklist()"
                                             [items]="sipHeadersOptions">
                                  </ac-select>
                                </ac-input-container>

                                <ac-input-container label="Values" class="list-action elements-select list-input">
                                  <ac-select class="sip-header-value"
                                             [(acModel)]="item.value"
                                             [attr.alternativeName]="index + '-sip-header-value'"
                                             (acModelChange)="updateIsInvalidMatchSipHeadersBlacklist()"
                                             [addCustomTags]="true"
                                             [bindLabel]="null"
                                             [bindValue]="null"
                                             [multiple]="true"
                                             [isOpen]="false"
                                             [allowClear]="true">
                                  </ac-select>
                                </ac-input-container>

                                <button (click)="removeSipHeader(index); updateIsInvalidMatchSipHeadersBlacklist()"
                                        mat-icon-button matTooltip="Delete" class="delete-button">
                                  <mat-icon [svgIcon]="'delete'" class="icon-display"></mat-icon>
                                </button>
                              </div>
                            </div>
                          </div>

                          <mat-error [ngStyle]="{'visibility': isInvalidMatchSipHeadersBlacklist ? 'visible' : 'hidden' }"
                                     class="uris-error">Name and values must be provided for each item</mat-error>
                        </div>
                      </div>
                    </div>
                </div>

                <div class="match-and-action-container" *acTab="'Action'; id: 'destination-tab'">
                    <div class="action" *ngIf="callItem.type == 'USER'">
                        <div class="action-container">
                            <div class="column-1">
                                <div class="list-container" style="margin-top: 10px;">
                                    <div class="list-actions">
                                        <button (click)="addActionAttribute(); updateIsInvalidActionsAttributesUser()" [disabled]="isActionSelectOptionListEmpty()" mat-icon-button matTooltip="Add">
                                            <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                                        </button>
                                    </div>
                                    <div class="list-box">
                                        <div *ngFor="let item of callItem.action.attributes;let isOdd=odd;let isEven=even;let index = index;"
                                             class="attribute-item list-item"
                                             [ngClass]="hasActionSelection(item)"
                                             (click)="selectActionCallItem(item)"
                                             [class.white]="isOdd"
                                             [class.gray]="isEven">

                                            <ac-input-container label="Match" class="match-type list-input">
                                                <ac-select [(acModel)]="item.field"
                                                           [searchable]="false"
                                                           (change)="updateActionSelectOptionList(); updateIsInvalidActionsAttributesUser()"
                                                           [items]="actionSelectOptionList"
                                                           [attr.alternativeName]="index + '-action-option'"
                                                           bindLabel="value"
                                                           bindValue="id">
                                                </ac-select>
                                            </ac-input-container>

                                            <select-from-dual-list sourceHeader="Options" targetHeader="Selected" class="list-input"
                                                                   [source]="getAttributeOptions(attributeOptionList, item.values)"
                                                                   [target]="item.values"
                                                                   [value]="item.sValue"
                                                                   [showValue]="true"
                                                                   [attr.alternativeName]="index + '-action-value'"
                                                                   (targetChange)="updateAttributeItemsChange($event, item); updateIsInvalidActionsAttributesUser(); updateIsInvalidMatchAttributesUser()"
                                                                   [bindLabel]="'name'" [bindValue]="'id'" width="220">
                                            </select-from-dual-list>

                                            <button (click)="removeActionAttribute(index); updateIsInvalidActionsAttributesUser()"
                                                    mat-icon-button matTooltip="Delete" class="delete-button">
                                                <mat-icon [svgIcon]="'delete'" class="icon-display"></mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <mat-error [ngStyle]="{'visibility': isEmptyAttributesForUser ? 'visible' : 'hidden' }"
                                           class="uris-error">At least one of the items must be filled</mat-error>
                                <div class="flow">
                                    <ac-input-container class="sip-manipulation-group" label="SIP manipulation group">
                                        <ac-select [(acModel)]="callItem.sipManipulationGroupId"
                                                   [searchable]="true"
                                                   (acModelChange)="updateIsInvalidActionsAttributesUser()"
                                                   [items]="sipManipulationGroups"
                                                   bindLabel="name"
                                                   bindValue="id"
                                                   [allowClear]="true">
                                        </ac-select>
                                    </ac-input-container>
                                    <ac-input-container class="flow-input" label="Flow">
                                        <ac-select [(acModel)]="callItem.flow"
                                                   [searchable]="false"
                                                   (acModelChange)="updateIsInvalidActionsAttributesUser()"
                                                   [items]="flowSelectedOptionList"
                                                   bindLabel="label"
                                                   bindValue="value">
                                        </ac-select>
                                    </ac-input-container>
                                    <ac-input-container class="flow-input" label="Continue to rule"
                                                        *ngIf="callItem.flow === 'CONTINUE_TO_RULE'" [required]="true"
                                                        [customError]="(callItem.continueToRuleId >= 0) ? null : 'Element is required'" >
                                        <ac-select [(acModel)]="callItem.continueToRuleId"
                                                   [searchable]="false"
                                                   [items]="policyStudioRules"
                                                   (acModelChange)="updateIsInvalidActionsAttributesUser()"
                                                   bindLabel="name"
                                                   bindValue="id">
                                        </ac-select>
                                    </ac-input-container>
                                </div>
                            </div>
                            <div class="column-2"></div>
                        </div>
                    </div>

                    <div class="action" *ngIf="callItem.type == 'NUMBER_PORTABILITY'">
                        <div class="action-container">
                            <div class="column-1">
                                <div class="web-services-container" style="margin-top: 10px;">

                                    <ac-input-container label="Web Service" [customError]="!callItem.numberPortability ? 'Web Service is required' : null"
                                                        [required]="true">
                                        <ac-select [(acModel)]="callItem.numberPortability"
                                                   [searchable]="false"
                                                   [items]="numberPortabilityList"
                                                   (acModelChange)="updateIsInvalidSipHeadersPortability()"
                                                   bindLabel="name"
                                                   bindValue="id">
                                        </ac-select>
                                    </ac-input-container>

                                    <ng-container *ngIf="isHxs1MaskingServiceSelected()">
                                        <ac-input-container label="Call direction">
                                            <ac-select [(acModel)]="callItem.direction"
                                                       [searchable]="false"
                                                       [items]="directionOptions"
                                                       bindLabel="name"
                                                       bindValue="id">
                                            </ac-select>
                                        </ac-input-container>

                                        <ac-input-container label="Source normalization for lookup">
                                            <ac-select [(acModel)]="callItem.srcNormalizationGroupId"
                                                       [searchable]="false"
                                                       [items]="normalizationGroupList"
                                                       [allowClear]="true"
                                                       bindLabel="groupName"
                                                       bindValue="id">
                                            </ac-select>
                                        </ac-input-container>

                                        <ac-input-container label="Destination normalization for lookup">
                                            <ac-select [(acModel)]="callItem.destNormalizationGroupId"
                                                       [searchable]="false"
                                                       [items]="normalizationGroupList"
                                                       [allowClear]="true"
                                                       bindLabel="groupName"
                                                       bindValue="id">
                                            </ac-select>
                                        </ac-input-container>
                                    </ng-container>

                                    <ng-container *ngIf="isNpslx1MaskingServiceSelected()">
                                        <ac-input-container label="Source normalization for lookup">
                                            <ac-select [(acModel)]="callItem.srcNormalizationGroupId"
                                                       [searchable]="false"
                                                       [items]="normalizationGroupList"
                                                       [allowClear]="true"
                                                       bindLabel="groupName"
                                                       bindValue="id">
                                            </ac-select>
                                        </ac-input-container>

                                        <ac-input-container label="Destination normalization for lookup">
                                            <ac-select [(acModel)]="callItem.destNormalizationGroupId"
                                                       [searchable]="false"
                                                       [items]="normalizationGroupList"
                                                       [allowClear]="true"
                                                       bindLabel="groupName"
                                                       bindValue="id">
                                            </ac-select>
                                        </ac-input-container>
                                    </ng-container>

                                    <ng-container *ngIf="isNpsb1MaskingServiceSelected()">
                                        <ac-input-container label="Call direction">
                                            <ac-select [(acModel)]="callItem.direction"
                                                       [searchable]="false"
                                                       [items]="directionOptions"
                                                       bindLabel="name"
                                                       bindValue="id">
                                            </ac-select>
                                        </ac-input-container>
                                    </ng-container>

                                    <ng-container *ngIf="isDidMaskingServiceSelected()">
                                        <ac-input-container label="Call direction">
                                            <ac-select [(acModel)]="callItem.direction"
                                                       [searchable]="false"
                                                       [items]="directionOptions"
                                                       bindLabel="name"
                                                       bindValue="id">
                                            </ac-select>
                                        </ac-input-container>

                                        <ac-input-container label="Source normalization for lookup">
                                            <ac-select [(acModel)]="callItem.srcNormalizationGroupId"
                                                       [searchable]="false"
                                                       [items]="normalizationGroupList"
                                                       [allowClear]="true"
                                                       bindLabel="groupName"
                                                       bindValue="id">
                                            </ac-select>
                                        </ac-input-container>

                                        <ac-input-container label="Destination normalization for lookup">
                                            <ac-select [(acModel)]="callItem.destNormalizationGroupId"
                                                       [searchable]="false"
                                                       [items]="normalizationGroupList"
                                                       [allowClear]="true"
                                                       bindLabel="groupName"
                                                       bindValue="id">
                                            </ac-select>
                                        </ac-input-container>

                                        <ng-container *ngIf="callItem.direction === 'OUTGOING'">
                                            <ac-input-container label="Pool" [required]="true" [customError]="callItem.poolId ? null : 'Pool is required'">
                                                <ac-select [(acModel)]="callItem.poolId"
                                                           (acModelChange)="isPoolValid()"
                                                           [searchable]="false"
                                                           [items]="poolNumbersList"
                                                           [allowClear]="true"
                                                           bindLabel="name"
                                                           bindValue="id">
                                                </ac-select>
                                            </ac-input-container>
                                        </ng-container>

                                        <ng-container *ngIf="callItem.direction === 'INCOMING'">
                                            <ac-input-container label="Match Incoming calls by">
                                                <ac-select [(acModel)]="callItem.didMatchType"
                                                           [searchable]="false"
                                                           [items]="matchByOptions"
                                                           bindLabel="name"
                                                           bindValue="id">
                                                </ac-select>
                                            </ac-input-container>
                                        </ng-container>

                                        <ng-container *ngIf="callItem.direction === 'OUTGOING'">
                                            <mat-form-field class="fullWidth">
                                                <mat-label>Call Expiration Time (minutes)</mat-label>
                                                <input matInput [(ngModel)]="callItem.callExpirationTime" required type="number" min="1"
                                                       name="call-expiration-time">
                                                <mat-error>
                                                    Call Expiration Time is <strong>required</strong>, minimum value is 1
                                                </mat-error>
                                            </mat-form-field>
                                        </ng-container>

                                        <ng-container *ngIf="callItem.direction === 'INCOMING'">
                                            <mat-form-field class="fullWidth">
                                                <mat-label>X-Header to add</mat-label>
                                                <input matInput [(ngModel)]="callItem.didXHeader" name="x-header">
                                            </mat-form-field>
                                        </ng-container>

                                    </ng-container>

                                    <ac-input-container class="sip-manipulation-group" label="SIP manipulation group">
                                        <ac-select [(acModel)]="callItem.sipManipulationGroupId"
                                                   [searchable]="true"
                                                   (acModelChange)="updateIsInvalidActionsAttributesUser()"
                                                   [items]="sipManipulationGroups"
                                                   bindLabel="name"
                                                   bindValue="id"
                                                   [allowClear]="true">
                                        </ac-select>
                                    </ac-input-container>
                                </div>
                                <div class="flow-web-service">
                                    <ac-input-container class="flow-input" label="Flow">
                                        <ac-select [(acModel)]="callItem.flow"
                                                   [searchable]="false"
                                                   [items]="flowSelectedOptionList"
                                                   bindLabel="label"
                                                   bindValue="value">
                                        </ac-select>
                                    </ac-input-container>
                                    <ac-input-container class="flow-input" label="Continue to rule" *ngIf="callItem.flow === 'CONTINUE_TO_RULE'">
                                        <ac-select [(acModel)]="callItem.continueToRuleId"
                                                   [searchable]="false"
                                                   [items]="policyStudioRules"
                                                   bindLabel="name"
                                                   bindValue="id">
                                        </ac-select>
                                    </ac-input-container>
                                </div>
                            </div>
                            <div class="column-2">
                            </div>
                        </div>
                    </div>

                    <div class="action" *ngIf="callItem.type == 'CREDENTIALS'">
                        <div class="action-container">
                            <div class="column-1">
                                <div class="list-container" style="margin-top: 10px;">
                                    <div class="list-box">
                                        <div *ngFor="let item of callItem.action.credentials;let isOdd=odd;let isEven=even;let index = index;"
                                             class="attribute-item list-item"
                                             [ngClass]="hasActionSelection(item)"
                                             (click)="selectActionCallItem(item); updateIsInvalidActionsCredentials()"
                                             [class.white]="isOdd"
                                             [class.gray]="isEven">

                                            <ac-input-container label="Match" class="match-type list-input">
                                                <ac-select [(acModel)]="item.field"
                                                           [searchable]="false"
                                                           (acModelChange)="updateIsInvalidActionsCredentials()"
                                                           [items]="actionCredentialsSelectedOptionList"
                                                           [ngClass]="{'action-without-attributes': item.field === getCredentialsActionFieldId('DISCARD_CREDENTIALS')}"
                                                           bindLabel="value"
                                                           bindValue="id">
                                                </ac-select>
                                            </ac-input-container>

                                            <select-from-dual-list *ngIf="item.field === getCredentialsActionFieldId('CREDENTIALS')"
                                                                   sourceHeader="Options" targetHeader="Selected" class="list-input"
                                                                   [source]="getAttributeOptions(attributeOptionList, item.values)"
                                                                   [target]="item.values"
                                                                   [attr.alternativeName]="index + '-action-value'"
                                                                   (targetChange)="updateAttributeItemsChange($event, item); updateIsInvalidActionsCredentials()"
                                                                   [bindLabel]="'name'" [bindValue]="'id'" width="230">
                                            </select-from-dual-list>
                                        </div>
                                    </div>
                                </div>
                                <mat-error [ngStyle]="{'visibility': isInvalidActionsCredentials ? 'visible' : 'hidden' }"
                                           class="uris-error">At least one of the items must be filled</mat-error>
                            </div>
                            <div class="column-2"></div>
                        </div>
                    </div>

                    <div class="action" *ngIf="callItem.type == 'BLACK_LIST'">
                        <div class="action-container">
                            <div class="column-1">
                                <ac-input-container class="src-dest_calls" label="Source or Destination number">
                                    <ac-select class="single-row"
                                               [(acModel)]="callItem.action.sourceOrDestinationNumber"
                                               [multiple]="false"
                                               [items]="blackListMode"
                                               bindLabel="name"
                                               bindValue="id"
                                               [allowClear]="false">
                                    </ac-select>
                                </ac-input-container>

                                <div class="relative-time-label-wrapper">
                                    <div>
                                        <ac-line-separator class="line-separatro" title="Condition" ></ac-line-separator>
                                    </div>
                                    <div class="blocking-properties">
                                        <mat-form-field class="fullWidth">
                                            <mat-label>Call time range (sec)</mat-label>
                                            <input type="number" matInput [(ngModel)]="callItem.action.block.callWithinNumberSeconds" required [min]="10" [max]="10000" name="call-time-range">
                                            <mat-error>
                                                Call time range is <strong>required</strong>, minimum value is 10 and maximum value is 10000
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="blocking-properties">
                                        <mat-form-field class="fullWidth">
                                            <mat-label>Number of calls during time range criteria</mat-label>
                                            <input type="number" matInput [(ngModel)]="callItem.action.block.callOccursMoreThanNumberTimes" required [min]="1" [max]="10000" name="calls-during">
                                            <mat-error>
                                                Number of calls during time range criteria is <strong>required</strong>, minimum value is 1 and maximum value is 10000
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="">
                                        <ac-line-separator title="Action" ></ac-line-separator>
                                        <div class="blocking-properties">
                                            <mat-form-field class="fullWidth">
                                                <mat-label>Blocking number time period (min)</mat-label>
                                                <input type="number" matInput [(ngModel)]="callItem.action.block.blockNumberDuration" required [min]="1" [max]="10000"  name="blocking-time">
                                                <mat-error>
                                                    Blocking number time period is <strong>required</strong>, minimum value is 1 and maximum value is 10000
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="list-container" style="margin-top: 10px;">
                                    <div class="list-actions">
                                        <button (click)="addActionAttribute(); updateIsInvalidActionsAttributesBlacklist()" [disabled]="isActionSelectOptionListBlackListEmpty()" mat-icon-button matTooltip="Add">
                                            <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                                        </button>
                                    </div>
                                    <div class="list-box">
                                        <div *ngFor="let item of callItem.action.attributes;let isOdd=odd;let isEven=even;let index = index;"
                                             class="attribute-item list-item"
                                             [ngClass]="hasActionSelection(item)"
                                             (click)="selectActionCallItem(item)"
                                             [class.white]="isOdd"
                                             [class.gray]="isEven">

                                            <ac-input-container label="Match" class="match-type list-input">
                                                <ac-select [(acModel)]="item.field"
                                                           [searchable]="false"
                                                           (change)="updateActionSelectOptionList(); updateIsInvalidActionsAttributesBlacklist()"
                                                           [items]="this.blackListActionList"
                                                           [attr.alternativeName]="index + '-action-option'"
                                                           bindLabel="value"
                                                           bindValue="id">
                                                </ac-select>
                                            </ac-input-container>

                                            <select-from-dual-list sourceHeader="Options" targetHeader="Selected" class="list-input"
                                                                   [source]="getAttributeOptions(attributeOptionList, item.values)"
                                                                   [target]="item.values"
                                                                   [value]="item.sValue"
                                                                   [showValue]="true"
                                                                   [attr.alternativeName]="index + '-action-value'"
                                                                   (targetChange)="updateAttributeItemsChange($event, item); updateIsInvalidActionsAttributesBlacklist()"
                                                                   [bindLabel]="'name'" [bindValue]="'id'" width="220">
                                            </select-from-dual-list>

                                            <button (click)="removeActionAttribute(index); updateIsInvalidActionsAttributesBlacklist()"
                                                    mat-icon-button matTooltip="Delete" class="delete-button">
                                                <mat-icon [svgIcon]="'delete'" class="icon-display"></mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <mat-error [ngStyle]="{'visibility': isInvalidActionsAttributesBlacklist ? 'visible' : 'hidden' }"
                                           class="uris-error">Value must be provided for each tag</mat-error>
                            </div>
                            <div class="column-2">
                                <div class="flow">
                                    <ac-input-container label="Whitelist">
                                        <ac-select class="single-row"
                                                   [(acModel)]="callItem.action.whiteAttr"
                                                   [multiple]="true"
                                                   [addCustomTags]="true"
                                                   [items]="prefixGroups"
                                                   bindLabel="name"
                                                   [bindValue]="null"
                                                   [combinedMode]="true"
                                                   [allowClear]="true">
                                        </ac-select>
                                    </ac-input-container>
                                    <div class="generate-alarm">
                                        <mat-checkbox [(ngModel)]="callItem.action.alarm"
                                                      [ngModelOptions]="{standalone: true}"
                                                      name="Alarm"
                                                      color="primary">
                                            Generate alarm when number is blocked
                                        </mat-checkbox>
                                    </div>
                                    <ac-input-container class="flow-input" label="Flow">
                                        <ac-select [(acModel)]="callItem.flow"
                                                   [searchable]="false"
                                                   [items]="flowSelectedOptionList"
                                                   bindLabel="label"
                                                   bindValue="value">
                                        </ac-select>
                                    </ac-input-container>
                                    <ac-input-container class="flow-input" label="Continue to rule" *ngIf="callItem.flow === 'CONTINUE_TO_RULE'">
                                        <ac-select [(acModel)]="callItem.continueToRuleId"
                                                   [searchable]="false"
                                                   [items]="policyStudioRules"
                                                   bindLabel="name"
                                                   bindValue="id">
                                        </ac-select>
                                    </ac-input-container>
                                </div>
                            </div>
                        </div>
                    </div>
                  <div class="action" *ngIf="callItem.type == 'DIDS_COUNT_MATCH'">
                    <div class="action-container">
                      <div class="column-1">
                        <ac-input-container class="src-dest_calls" label="Source or Destination number">
                          <ac-select class="single-row"
                                     [(acModel)]="callItem.action.sourceOrDestinationNumber"
                                     [multiple]="false"
                                     [items]="blackListMode"
                                     bindLabel="name"
                                     bindValue="id"
                                     [allowClear]="false">
                          </ac-select>
                        </ac-input-container>

                        <div class="relative-time-label-wrapper">
                          <div>
                            <ac-line-separator class="line-separatro" title="Condition" ></ac-line-separator>
                          </div>
                          <div class="blocking-properties">
                            <mat-form-field class="fullWidth">
                              <mat-label>Number of calls from first hit</mat-label>
                              <input type="number" matInput [(ngModel)]="callItem.action.block.callOccursMoreThanNumberTimes" required [min]="1" [max]="10000" name="calls-during">
                              <mat-error>
                                Number of calls from first hit is <strong>required</strong>, minimum value is 1 and maximum value is 10000
                              </mat-error>
                            </mat-form-field>
                          </div>

                            <ac-line-separator title="Action" ></ac-line-separator>

                          <div class="grid-container">
                            <ng-container *ngFor="let option of this.didCountDurationTypeOptions; let i = index">
                              <mat-radio-group [(ngModel)]="callItem.action.block.didCountDurationType"
                                               [ngModelOptions]="{ standalone: true }" class="radio-group">
                                <mat-radio-button [value]="option.value" class="radio-button" color="primary"
                                                  (change)="onRadioChange(option, i)">
                                  {{ option.text }}
                                </mat-radio-button>
                              </mat-radio-group>
                              <div *ngIf="option.value==='MINUTES'">
                                <mat-form-field class="block-number-duration-container">
                                  <mat-label>Block Number Duration (min)</mat-label>
                                  <input type="number" matInput [(ngModel)]="callItem.action.block.blockNumberDuration"
                                         required [min]="1" [max]="10000" [disabled]="!isRowEnabled[i]"
                                         name="blocking-time">
                                  <mat-error>
                                    Blocking number time period is <strong>required</strong>, minimum value is 1 and
                                    maximum value is 10000
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div *ngIf="option.value==='TIME_OF_DAY'">
                                <div class="time-of-day">
                                  <label class="utc-label" [class.disabled]="!isRowEnabled[i]">UTC</label>
                                  <ac-input-container label="Hour" class="hours">
                                    <ac-select [acModel]="callItem.action.block.untilTimeOfDay.hours"
                                               [searchable]="false"
                                               (acModelChange)="callItem.action.block.untilTimeOfDay.hours = $event;"
                                               alternativeName="blockUntil.hours"
                                               [ngDisabled]="!isRowEnabled[i]"
                                               [items]="hoursOptions">
                                    </ac-select>
                                  </ac-input-container>
                                  <ac-input-container label="Minute" class="minutes">
                                    <ac-select [acModel]="callItem.action.block.untilTimeOfDay.minutes"
                                               [searchable]="false"
                                               (acModelChange)="callItem.action.block.untilTimeOfDay.minutes = $event;"
                                               alternativeName="blockUntil.minutes"
                                               [ngDisabled]="!isRowEnabled[i]"
                                               [items]="minutesOptions">
                                    </ac-select>
                                  </ac-input-container>
                                  <label class="local-label" [class.disabled]="!isRowEnabled[i]">Local Time</label>
                                  <div class="local-time-container" [class.disabled]="!isRowEnabled[i]">
                                    <span>{{((callItem.action.block.untilTimeOfDay.hours - this.timeZoneOffset / 60 + 24) % 24) > 9 ? ((callItem.action.block.untilTimeOfDay.hours - this.timeZoneOffset / 60 + 24) % 24) : "0" + ((callItem.action.block.untilTimeOfDay.hours - this.timeZoneOffset / 60 + 24) % 24)}}
                                      :</span>
                                    <span>{{callItem.action.block.untilTimeOfDay.minutes > 9 ? callItem.action.block.untilTimeOfDay.minutes : "0" + callItem.action.block.untilTimeOfDay.minutes}}</span>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                        <div class="list-container" style="margin-top: 10px;">
                          <div class="list-actions">
                            <button (click)="addActionAttribute(); updateIsInvalidActionsAttributesBlacklist()" [disabled]="isActionSelectOptionListBlackListEmpty()" mat-icon-button matTooltip="Add">
                              <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                            </button>
                          </div>
                          <div class="list-box">
                            <div *ngFor="let item of callItem.action.attributes;let isOdd=odd;let isEven=even;let index = index;"
                                 class="attribute-item list-item"
                                 [ngClass]="hasActionSelection(item)"
                                 (click)="selectActionCallItem(item)"
                                 [class.white]="isOdd"
                                 [class.gray]="isEven">

                              <ac-input-container label="Match" class="match-type list-input">
                                <ac-select [(acModel)]="item.field"
                                           [searchable]="false"
                                           (change)="updateActionSelectOptionList(); updateIsInvalidActionsAttributesBlacklist()"
                                           [items]="this.blackListActionList"
                                           [attr.alternativeName]="index + '-action-option'"
                                           bindLabel="value"
                                           bindValue="id">
                                </ac-select>
                              </ac-input-container>

                              <select-from-dual-list sourceHeader="Options" targetHeader="Selected" class="list-input"
                                                     [source]="getAttributeOptions(attributeOptionList, item.values)"
                                                     [target]="item.values"
                                                     [value]="item.sValue"
                                                     [showValue]="true"
                                                     [attr.alternativeName]="index + '-action-value'"
                                                     (targetChange)="updateAttributeItemsChange($event, item); updateIsInvalidActionsAttributesBlacklist()"
                                                     [bindLabel]="'name'" [bindValue]="'id'" width="220">
                              </select-from-dual-list>

                              <button (click)="removeActionAttribute(index); updateIsInvalidActionsAttributesBlacklist()"
                                      mat-icon-button matTooltip="Delete" class="delete-button">
                                <mat-icon [svgIcon]="'delete'" class="icon-display"></mat-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                        <mat-error [ngStyle]="{'visibility': isInvalidActionsAttributesBlacklist ? 'visible' : 'hidden' }"
                                   class="uris-error">Value must be provided for each tag</mat-error>
                      </div>
                      <div class="column-2">
                        <div class="flow">

                          <ac-input-container class="flow-input" label="Flow">
                            <ac-select [(acModel)]="callItem.flow"
                                       [searchable]="false"
                                       [items]="flowSelectedOptionList"
                                       bindLabel="label"
                                       bindValue="value">
                            </ac-select>
                          </ac-input-container>
                          <ac-input-container class="flow-input" label="Continue to rule" *ngIf="callItem.flow === 'CONTINUE_TO_RULE'">
                            <ac-select [(acModel)]="callItem.continueToRuleId"
                                       [searchable]="false"
                                       [items]="policyStudioRules"
                                       bindLabel="name"
                                       bindValue="id">
                            </ac-select>
                          </ac-input-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </ac-tabs>
        </div>
        <ng-template #nodesDiagram>
            <div style="height: 580px; width: 800px">
                <choose-topology-item-container [diagramId]="'nodes-diagram'"
                                                [options]="nodesDiagramOptions"
                                                (onClick)="onNodesDiagramClick($event)">
                </choose-topology-item-container>
            </div>
        </ng-template>

        <ng-template #pconsDiagram>
            <div style="height: 580px; width: 800px">
                <choose-topology-item-container [diagramId]="'pcons-diagram'"
                                                [options]="pConsOptions"
                                                (onClick)="onPConsDiagramClick($event)">
                </choose-topology-item-container>
            </div>
        </ng-template>

        <ng-template #reroutePconsDiagram>
          <div style="height: 580px; width: 800px">
            <choose-topology-item-container [diagramId]="'pcons-diagram'"
                                            [options]="reroutePConsOptions"
                                            (onClick)="onReroutePConsDiagramClick($event)">
            </choose-topology-item-container>
          </div>
        </ng-template>

    </div>
</form>
